import { Injectable } from '@angular/core';
import { Subject, Subscription } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private arregloSubject: { [key: string]: Subject<any> } = {};

  constructor() { }

  crearValidarSubject(eventName: string) {
    if (!this.arregloSubject[eventName])
      this.arregloSubject[eventName] = new Subject<any>();
  }

  publish(eventName: string, data: any = null) {
    this.crearValidarSubject(eventName);
    this.arregloSubject[eventName].next(data);
  }

  subscribe(eventName: string, callback: (data?: any) => void = () => { }): Subscription {
    this.crearValidarSubject(eventName);
    return this.arregloSubject[eventName].subscribe(callback);
  }
}
